import { FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { CustomRoute } from 'components/Core/CustomRoute';
import { Navbar } from 'components/Core/Navbar';
import { PopUp } from 'components/Core/PopUp';
import { CustomAlert } from 'components/Core/CustomAlert';
import { ServerChecker } from 'components/Core/ServerChecker';
import { AppLoader } from 'components/Core/AppLoader';
import { NoCountries } from 'components/Core/NoCountries';

const Router: FC = observer(() => {
  const {
    mainStore: { userRoutes, globalLoading, hasNoCountry },
    alertStore: { show },
    popUpStore: { open },
  } = useStore();

  return (
    <BrowserRouter>
      <ServerChecker>
        <Routes>
          {userRoutes.map(({ path, disableNavbar, component, isPrivate }, key) => (
            <Route
              key={path + key}
              path={path}
              element={
                <>
                  {globalLoading ? (
                    <AppLoader />
                  ) : hasNoCountry ? (
                    <NoCountries />
                  ) : (
                    <CustomRoute isPrivate={isPrivate}>
                      <div style={{ overflow: 'hidden', display: 'flex' }}>
                        {!disableNavbar ? <Navbar /> : null}
                        <div
                          style={{
                            width: '100%',
                            height: '100vh',
                            overflow: 'auto',
                          }}>
                          {component}
                        </div>
                      </div>
                      {open ? <PopUp /> : null}
                      {show ? <CustomAlert /> : null}
                    </CustomRoute>
                  )}
                </>
              }
            />
          ))}
        </Routes>
      </ServerChecker>
    </BrowserRouter>
  );
});

export default Router;
